import { render, staticRenderFns } from "./FiveGear.vue?vue&type=template&id=b49b4828&scoped=true&"
import script from "./FiveGear.vue?vue&type=script&lang=js&"
export * from "./FiveGear.vue?vue&type=script&lang=js&"
import style0 from "./FiveGear.vue?vue&type=style&index=0&id=b49b4828&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b49b4828",
  null
  
)

export default component.exports